import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>Per regulation, providers are required to dispense the least costly generically equivalent formula to meet the medical need. When claiming, be prepared to supply such documentation. </p>
				
				<div className="button" onClick={()=>this.props.navigate('D22')}>Continue</div>
			</div>
		);
	}
}